module.exports = __webpack_public_path__ + "img/hkstp.86c186aa.png";